export default {
  pageDesc: '选择业务流程后配置工位与设备；一个拣选工位对应一个播种架（36 个播种框），架上可同时承接多个订单',
  paramTitle: '派单参数',
  paramHint: '业务流程决定本单包含哪些步骤与可配置项',
  flowLabel: '业务流程',
  flowTip: '全流程＝拣选后自动流转复核；仅拣选＝只执行拣选；仅复核＝只执行复核。决定本单包含哪些步骤与可配置项。',
  flowAll: '全流程',
  flowPick: '仅拣选',
  flowChk: '仅复核',
  flowNoteAll: '全流程：拣选完成后自动流转复核，拣选与复核工位、设备均可配置。',
  flowNotePick: '仅拣选：只执行拣选步骤，拣选闭单即结束；复核工位与复核执行设备不可配置。',
  flowNoteChk: '仅复核：只执行复核步骤，不依赖拣选；拣选工位与拣选执行设备不可配置。',
  pickStation: '拣选工位',
  pickStationTip: '货架停靠并完成拣选的工位。一个拣选工位对应一个播种架（4 行 × 9 列 ＝ 36 个播种框）。仅复核流程不涉及。',
  chkStation: '复核工位',
  chkStationTip: '复核作业发生的工位，与拣选工位一一对应（PW-01 ↔ RC-01）。仅拣选流程不涉及。',
  position: '停靠位',
  positionTip: '货架在该工位上的停靠位置：左位 L / 右位 R。现场位置固定，由派单人工指定；与架号关联后合成完整架位码（例 L01A-2F）。',
  positionL: '左位 L',
  positionR: '右位 R',
  pickDevice: '拣选执行设备',
  pickDeviceTip: '执行拣选作业的机器人。仅复核流程不涉及。',
  chkDevice: '复核执行设备',
  chkDeviceTip: '执行复核作业的机器人。仅拣选流程不涉及。',
  lockPickStation: '本流程不涉及拣选，工位不可配置',
  lockChkStation: '本流程不涉及复核，工位不可配置',
  lockPickDevice: '本流程不涉及拣选，设备不可配置',
  lockChkDevice: '本流程不涉及复核，设备不可配置',
  expectTime: '期望完成时间',
  expectTimeTip: '本单的计划完成时间，用于排产与超期提醒。',
  devicePickIdle: 'TermiBot T1-001（拣选 · 空闲 · 电量 96%）',
  devicePickBusy: 'TermiBot T1-003（拣选 · 执行中 · 排队）',
  devicePickIdle2: 'TermiBot T1-005（拣选 · 空闲 · 电量 88%）',
  deviceChkIdle: 'TermiBot T1-002（复核 · 空闲 · 电量 92%）',
  deviceChkBusy: 'TermiBot T1-004（复核 · 执行中 · 排队）',
  deviceChkIdle2: 'TermiBot T1-006（复核 · 空闲 · 电量 90%）',
  devicePickLabel: '{sn}（拣选）',
  deviceChkLabel: '{sn}（复核）',
  devicePickOnline: '{sn}（拣选 · 电量 {battery}）',
  deviceChkOnline: '{sn}（复核 · 电量 {battery}）',
  devicePickOffline: '{sn}（拣选 · 离线）',
  deviceChkOffline: '{sn}（复核 · 离线）',
  deviceEmpty: '暂无可用设备',
  stationPw01: 'PW-01（播种架 B103A-19 · 空闲框 28/36）',
  stationPw02: 'PW-02（播种架 B103A-20 · 空闲框 36/36）',
  stationPw03: 'PW-03（播种架 B103A-21 · 空闲框 12/36）',
  stationRc01: 'RC-01（随拣选工位 PW-01 选定）',
  stationRc02: 'RC-02（随拣选工位 PW-02 选定）',
  stationRc03: 'RC-03（随拣选工位 PW-03 选定）',
  stationPickLabel: '{code}（播种架 {basket} · {status}）',
  stationChkFollow: '{code}（随拣选工位 {pick} 选定）',
  stationChkLabel: '{code}（播种架 {basket} · {status}）',
  stationStatusIdle: '空闲',
  stationStatusBusy: '占用中',
  stationEmpty: '暂无可用工位',
  orderTitle: '① 选择订单（可多选）',
  orderHint: '点选订单加入本次任务；同一工位的播种架可同时承接多个订单',
  orderSelCnt: '已选 {n} 个',
  orderMeta: '{skuCount} 个 SKU · 共 {qty} 件',
  orderLoading: '工单加载中…',
  orderEmpty: '暂无可用工单',
  createOrder: '生成订单',
  createOrderTitle: '生成订单',
  createOrderColProduct: '商品',
  createOrderColQty: '数量',
  createOrderSkuPlaceholder: '请选择商品',
  createOrderSkuRequired: '请为每一行选择商品',
  createOrderSkuDuplicate: '商品不能重复',
  createOrderQtyPlaceholder: '数量',
  createOrderQtyRequired: '请填写各行数量',
  createOrderStopPos: '停靠位',
  createOrderStopPosPlaceholder: '请选择停靠位',
  createOrderStopPosRequired: '请选择停靠位',
  createOrderLayer: '货架层数',
  createOrderLayerPlaceholder: '如 L1',
  createOrderLayerRequired: '请填写货架层数',
  createOrderBoxPos: '纸箱位置',
  createOrderBoxPosPlaceholder: '请填写纸箱位置',
  createOrderBoxPosRequired: '请填写纸箱位置',
  createOrderTotal: '总件数',
  createOrderAdd: '+ 添加一行',
  createOrderRemove: '删除',
  createOrderEmpty: '请添加 SKU 行',
  createOrderOk: '确定',
  createOrderCancel: '取消',
  createOrderSuccess: '订单生成成功',
  createOrderFail: '订单生成失败',
  skuTitle: '② 选择 SKU 与数量',
  skuHint: '由已选订单汇总而来，可移除不需要的 SKU 行',
  skuEmpty: '请先在上方选择订单（可多选），SKU 明细会自动汇总到这里。',
  skuSoftNote: '数量取自订单需求件数，不可修改。一个订单对应播种架上的一个播种框。',
  remove: '移除',
  colOrder: '订单',
  colSku: 'SKU',
  colName: '商品',
  colForm: '形态',
  colLocShort: '架位',
  colStopPos: '停靠位',
  colLayer: '货架层数',
  colBoxPos: '纸箱位置',
  colBarcode: '条形码',
  stopPosLeft: '左位L',
  stopPosRight: '右位R',
  colPickQty: '拣选数量',
  colAction: '操作',
  wallTitle: '③ 播种架配置',
  wallHint: '系统按订单自动分配播种框，点击框可解绑 / 恢复（一个订单只占一个框）',
  wallUsage: '占用 {n} / {total}',
  wallLoading: '播种框加载中…',
  wallAuto: '重新自动分配',
  wallTip: '点已占用的框＝解绑该订单；点空闲框＝绑入下一条未绑定订单（一个订单只占一个框）',
  wallUnbound: '未绑定 {n} 个订单',
  wallBoundAll: '订单已全部绑定播种框',
  wallEmpty: '尚未绑定播种框 —— 请先选择订单。',
  colFrame: '播种框',
  colOrderFull: '订单',
  colSkuCount: 'SKU 数',
  colSkuQty: 'SKU × 数量',
  colNeed: '应投',
  colStatus: '状态',
  pendingDrop: '待投',
  frameOffline: '已下架',
  frameTipBound: '{pos} · {order} · {skuCount} 个 SKU · {qty} 件（点击解绑）',
  frameTipFreeBind: '{pos} · 空闲（点击绑入下一条未绑定订单）',
  frameTipFree: '{pos} · 空闲',
  frameTipOffline: '{pos} · 已下架',
  toastFrameOffline: '该播种框已下架，无法绑定',
  summaryTitle: '派单汇总',
  sFlow: '业务流程',
  sPickSt: '拣选工位',
  sChkSt: '复核工位',
  sPos: '停靠位',
  sFullBay: '完整架位码',
  sOrders: '订单数',
  sSrc: 'SKU / 架位',
  sCount: '商品件数',
  sFrames: '播种框占用',
  sPickDev: '拣选设备',
  sChkDev: '复核设备',
  sPolicy: '异常策略',
  policyText: '业务异常挂起该行 · 等人工决策 · 事后留痕',
  unselected: '未选择',
  undetermined: '未确定',
  pendingSku: '待选 SKU',
  notInvolved: '—（不涉及）',
  ordersCount: '{n} 个',
  countText: '{n} 件',
  skuLoc: '{sku} → {loc}',
  submit: '提交派单',
  reset: '重置',
  submitNoteAll: '提交后按全流程生成任务并占用播种框；拣选闭单后自动流转复核。',
  submitNotePick: '提交后生成仅拣选任务并占用播种框；拣选闭单即结束，不流转复核。',
  submitNoteChk: '提交后生成仅复核任务；按既有播种框整框核对，不占用新的播种框。',
  toastSelectOrder: '请先选择至少一个订单',
  toastSkuEmpty: 'SKU 明细为空，请检查订单',
  toastSelectWall: '请先配置播种架（至少占用一个播种框）',
  toastNoUnbound: '没有未绑定的订单了',
  toastOrderNoSku: '该订单没有 SKU 行',
  toastWallAuto: '已按订单顺序重新绑定播种框',
  toastSubmit: '派单已提交：生成任务 {no}（包括 {n} 个订单）',
  toastSubmitFail: '派单提交失败，请稍后重试',
  toastReset: '派单参数已重置',
}
